export default __webpack_public_path__ + "static/favicon-de63848998ce3760b8dc2456220d193b.ico";